import classNames from 'classnames';
import React from 'react';

export interface GridProps extends React.HTMLAttributes<HTMLDivElement> { }

const Grid: React.FC<GridProps> & {
  Row: typeof GridRow
  Col: typeof GridCol
} = ({
  className,
  children,
  ...props
}) => {
    const classes = classNames(
      "uc-grid",
      className
    )

    return (
      <div className={classes} {...props}>
        {children}
      </div>
    );
  };

export interface GridRowProps extends React.HTMLProps<HTMLDivElement> { }

const GridRow: React.FC<GridRowProps> = ({
  className,
  children,
  ...props
}) => {
  const classes = classNames(
    "uc-grid__row",
    className,
  );

  return <div className={classes} {...props} >
    {children}
  </div>;
}

export interface GridColProps extends React.HTMLProps<HTMLDivElement> {
  /**
   * カラム数
   * 1~12 で指定できます.
   */
  col?: number;

  /**
   * ウィンドウサイズが middle: 1280px; 以上 のカラム数
   * 1~12 で指定できます.
   */
  colL?: number;

  /**
   * ウィンドウサイズが middle: 1280px; 未満, small: 600px; 以上 のカラム数
   * 1~12 で指定できます.
   */
  colM?: number;

  /**
   * ウィンドウサイズが small: 600px; 未満 のカラム数
   * 1~12 で指定できます.
   */
  colS?: number;

  /**
   * オフセット(左に何カラムスペースを空けるか)
   * 1~12 で指定できます.
   */
  offset?: number;

  /**
   * ウィンドウサイズが middle: 1280px; 以上 のオフセット
   * 1~12 で指定できます.
   */
  offsetL?: number;

  /**
   * ウィンドウサイズが middle: 1280px; 未満, small: 600px; 以上 のオフセット
   * 1~12 で指定できます.
   */
  offsetM?: number;

  /**
   * ウィンドウサイズが small: 600px; 未満 のオフセット
   * 1~12 で指定できます.
   */
  offsetS?: number;
}

const GridCol: React.FC<GridColProps> = ({
  className,
  children,
  col,
  colL,
  colM,
  colS,
  offset,
  offsetL,
  offsetM,
  offsetS,
  ...props
}) => {
  const classes = classNames(
    "uc-grid__col",
    col !== undefined && `uc-grid__col--${col}`,
    colL !== undefined && `uc-grid__col--l${colL}`,
    colM !== undefined && `uc-grid__col--m${colM}`,
    colS !== undefined && `uc-grid__col--s${colS}`,
    offset !== undefined && `uc-grid__col--offset${offset}`,
    offsetL !== undefined && `uc-grid__col--offset-l${offsetL}`,
    offsetM !== undefined && `uc-grid__col--offset-m${offsetM}`,
    offsetS !== undefined && `uc-grid__col--offset-s${offsetS}`,
    className,
  );

  return <div className={classes} {...props} >
    {children}
  </div>;
}

Grid.Row = GridRow;
Grid.Col = GridCol;

export default Grid;